module.exports = __webpack_public_path__ + "img/Buma_Stemra.f08b9502.svg";